import React from 'react';
import { Table, Panel } from 'react-bootstrap';
import { formatTotal } from '../helpers';

function totalWeightLifted(props) {
    const { sets } = props;
    if(sets) {
      return Object.keys(sets)
        .reduce((accumulator, key) => {
          const set = sets[key];
          if(set) {
            return accumulator + set.weight * set.reps;
          }
          return accumulator;
       }, 0); 
    }

    return 0;
}

function minutesTrained(workout) {
    const { sets } = workout;
    if(!sets) {
        return 0;
    }
    // get maximum timestamp in sets
    const lastTimestamp = Object.keys(workout.sets)
                                .map(key => workout.sets[key].timeStamp)
                                .reduce((prev, curr) => curr > prev ? curr : prev, 0)
    
    // subtract from workout start timeStamp
    const totalMilliseconds = lastTimestamp - workout.timeStamp;

    // convert to minutes
    return totalMilliseconds / 60000;
}

const WorkoutStats = ({workout}) => (
    <Panel>
        <Table fill striped condensed>
            <tbody>
                <tr>
                    <td>Total lifted</td><td><strong>{formatTotal(totalWeightLifted(workout))}</strong></td>
                </tr>
                <tr>
                    <td>TMT</td><td>{minutesTrained(workout).toLocaleString() + ' min'}</td>
                </tr>
            </tbody>
        </Table>
    </Panel>
);

WorkoutStats.propTypes = {
    workout: React.PropTypes.object.isRequired
}

export default WorkoutStats;


// WEBPACK FOOTER //
// ./src/components/WorkoutStats.jsx